import { ProviderIcon } from "@/components/ui/ProviderIcon";
import * as shared from "@/styles/shared";
import type { InvoiceRowProps } from "@/types/ui";
import { formatAddressProviderLabel, formatCurrency, formatDate } from "@platko/shared/utils";
import { CalendarDays, Check } from "lucide-react";
import * as invoiceRowStyles from "./InvoiceRow.styles";
import * as styles from "./Payment.styles";

const InvoiceRow = ({ inv, checked, onToggle }: InvoiceRowProps) => (
  <div className={checked ? invoiceRowStyles.rowChecked : invoiceRowStyles.rowUnchecked}>
    <button type="button" onClick={onToggle} className={checked ? invoiceRowStyles.checkboxBtnChecked : invoiceRowStyles.checkboxBtnUnchecked}>
      {checked && <Check className="h-3 w-3 text-primary-foreground" />}
    </button>
    <div className={invoiceRowStyles.innerDiv}>
      <div className={invoiceRowStyles.nameGroup}>
        <ProviderIcon provider={inv.addressProvider.provider.name} size="sm" />
        <span className={invoiceRowStyles.nameText}>
          {formatAddressProviderLabel(inv.addressProvider.address.name, inv.addressProvider.provider.name)}
        </span>
      </div>
    </div>
    <div className={styles.flexCenter}>
      <div className={shared.rowGap1}>
        <CalendarDays className={invoiceRowStyles.icon} />
        <span className={shared.mutedBase}>{formatDate(inv.invoiceDate)}</span>
      </div>
      <span className={styles.fontMonoBold}>{formatCurrency(inv.amount)}</span>
    </div>
  </div>
);

export { InvoiceRow };
